module.exports = __webpack_public_path__ + "media/music.9d63ae80.mp3";